import {QualityCheckProjectFiles} from '../../../../api';
import {StatusSummary, summarizeStatus} from '../../../../models/report/normalized-report.model';

export type QualityResultStatus = 'success' | 'warning' | 'error';

/**
 * Status einer Ergebnisliste des All-Right Checks: das schlechteste Einzelergebnis.
 * Dieselbe Regel wie am Badge der Prüfregel-Zeile im Bericht.
 */
export function statusForQualityResults(results: ReadonlyArray<{ type?: string }>): QualityResultStatus {
  const types = results.map(result => result.type);
  if (types.includes('error')) return 'error';
  if (types.includes('warning')) return 'warning';
  return 'success';
}

/** Ergebnisse je Prüfregel (`codeId` → Einzelergebnisse) einer geprüften Datei. */
function resultsByRule(file: QualityCheckProjectFiles): Record<string, Array<{ type?: string }>> {
  return file.check?.result ?? {};
}

/**
 * Anzahl der tatsächlich geprüften Prüfregeln – jede Regel einmal, egal in wie vielen Dateien sie
 * lief. Vorher stand im Header die Anzahl der Dateien (#2658).
 */
export function qualityCheckedRuleCount(files: ReadonlyArray<QualityCheckProjectFiles>): number {
  return new Set(files.flatMap(file => Object.keys(resultsByRule(file)))).size;
}

/**
 * Statusverteilung für die Overview-Kreise: je Datei und Prüfregel ein Eintrag mit dem Status, den
 * auch die Prüfregel-Zeile zeigt – wie im generischen Bericht (`summaryItems`). Vorher zählte je
 * Datei nur das schlechteste Ergebnis über alle Regeln; eine einzige nicht erfüllte Regel pro Datei
 * machte das Diagramm so zu 100 % rot, auch wenn die übrigen Regeln erfüllt waren (#2658).
 */
export function qualityStatusSummary(files: ReadonlyArray<QualityCheckProjectFiles>): StatusSummary {
  const items = files.flatMap(file => Object.values(resultsByRule(file))
    .map(results => ({status: statusForQualityResults(results)})));
  return summarizeStatus(items);
}
